import Parser from 'html-react-parser';
import React from 'react';

export const HtmlParser = ({ children }) => {
    return <>{Parser(children)}</>;
};
